import type { MenuItemProps } from "@mui/material";
import { MenuItem } from "@mui/material";

const MenuItemWithoutHighlight = (props: MenuItemProps) => (
  <MenuItem
    {...props}
    sx={{
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&.Mui-selected": {
        backgroundColor: "transparent",
        "& .MuiTypography-root": {
          color: "inherit",
        },
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    }}
  />
);

export default MenuItemWithoutHighlight;
